import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bmf_token");
    const stored = localStorage.getItem("bmf_user");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch (_) {}
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("bmf_user", JSON.stringify(r.data));
      }).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bmf_token", data.token);
    localStorage.setItem("bmf_user", JSON.stringify(data.user));
    // Fetch full permissions right after login
    try {
      const me = await api.get("/auth/me");
      localStorage.setItem("bmf_user", JSON.stringify(me.data));
      setUser(me.data);
      return me.data;
    } catch (_) {
      setUser(data.user);
      return data.user;
    }
  };

  const hasPerm = (module, action = "view") => {
    if (!user) return false;
    if ((user.role_id || user.role) === "super_admin") return true;
    const perms = user.permissions_effective || {};
    return (perms[module] || []).includes(action);
  };

  const logout = () => {
    localStorage.removeItem("bmf_token");
    localStorage.removeItem("bmf_user");
    setUser(null);
    // Preserve context: mobile PWA users return to mobile login, others to desktop login.
    const target = window.location.pathname.startsWith("/m") ? "/m/login" : "/login";
    window.location.href = target;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser, hasPerm }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
